import { Button, CircularProgress, Container, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import FormSection from '../../../components/atom/FormSection';
import { useNotify } from '../../../hooks/useNotify';
import { doSwaggerCall, useSwaggerClient } from '../../../hooks/useSwaggerClient';
import ReaderCreateOrEditForm from './components/ReaderCreateOrEditForm';

const ReaderEditPage = () => {
    const history = useHistory();
    const { readerId } = useParams();
    const { notifySuccess } = useNotify();
    const [stripeError, setStripeError] = useState(false);
    const [reader, loadingReader, readerError] = useSwaggerClient('terminals', 'getReader', {
        readerId
    });

    const onSubmit = (values, { setSubmitting }) => {
        doSwaggerCall('terminals', 'updateReader', {
            readerId,
            readerData: {
                label: values.label
            }
        })
            .then(() => {
                notifySuccess('Successfully updated location');
                setStripeError(false);
            })
            .catch(err => {
                setStripeError(`${err.code} - ${err.message}`);
            })
            .finally(() => {
                setSubmitting(false);
                history.goBack();
            });
    };

    return (
        <Container>
            <Grid container item xs={12} spacing={2} className="mt-2">
                {loadingReader ? (
                    <Grid container item xs={12} spacing={2} justifyContent="flex-end">
                        <CircularProgress />
                    </Grid>
                ) : (
                    <>
                        <Grid container item xs={12} spacing={2} justifyContent="flex-end">
                            <Button onClick={() => history.goBack()}>Back</Button>
                        </Grid>
                        <FormSection title="Edit location">
                            <Grid item xs={12}>
                                {stripeError && (
                                    <Alert severity="error" className="mb-2">
                                        {stripeError}
                                    </Alert>
                                )}
                                {readerError ? (
                                    <Alert severity="error">
                                        <h4>Could not load reader.</h4>
                                    </Alert>
                                ) : (
                                    <ReaderCreateOrEditForm
                                        initialValues={reader}
                                        onSubmit={onSubmit}
                                        stripeError={stripeError}
                                        onBack={() => {
                                            setStripeError(false);
                                            history.goBack();
                                        }}
                                    />
                                )}
                            </Grid>
                        </FormSection>
                    </>
                )}
            </Grid>
        </Container>
    );
};

export default ReaderEditPage;
